export const setAgents = (agents) => ({
    type: "SET_AGENTS",
    payload: agents,
  });

  export const setAgentsIds = (agentsIds) => ({
    type: "SET_AGENTS_IDS",
    payload: agentsIds,
  });
  export const setAgentsProfiles = (agentsProfiles) => ({
    type: "SET_AGENTS_PROFILES",
    payload: agentsProfiles,
  });